<rwidget-pattern-schedule-on-stop></rwidget-pattern-schedule-on-stop>
